import { render } from "./WhatDesign.vue?vue&type=template&id=a9029bf0"
import script from "./WhatDesign.vue?vue&type=script&lang=js"
export * from "./WhatDesign.vue?vue&type=script&lang=js"

import "./WhatDesign.vue?vue&type=style&index=0&id=a9029bf0&lang=scss"
script.render = render

export default script